import PropTypes from 'prop-types';
import React from 'react';
import './index.scss';
import { Typography } from 'antd';
import { formatPaymentMode } from 'pages/DashBoardPage/const';
import currencyFormat from 'utils/currencyFormat';

function CustomTooltip({ active, payload }) {
  if (active && payload && payload.length) {
    const { mode, total } = payload[0].payload;
    const bgColor = total >= 0 ? '#009D19' : '#f87171'; // Green or Red

    return (
      <div style={{ '--tooltip-bg': bgColor, padding: '15px' }} className="custom-tooltip">
        <Typography className="tooltip-label">Commission Earned</Typography>
        <div>
          <Typography className="tooltip-sub-label">
            {formatPaymentMode(mode)} : ₹{currencyFormat(total, true, false)}
          </Typography>
        </div>
      </div>
    );
  }

  return null;
}

CustomTooltip.propTypes = {
  active: PropTypes.bool.isRequired,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      payload: PropTypes.shape({
        mode: PropTypes.string,
        total: PropTypes.number
      })
    })
  ).isRequired
};

export default CustomTooltip;
